/* Quote form handler for the static build.
 *
 * The original site ran Contact Form 7 on WordPress and POSTed to
 * /wp-json/contact-form-7/... . There is no WordPress here, so that endpoint is
 * gone and submissions would fail silently. This script takes over the submit.
 *
 * >>> SET THIS before going live, or the form will refuse to send. <<<
 * Any endpoint that accepts a POST works — Formspree, Web3Forms, Netlify Forms,
 * Basin, or your own handler. Examples:
 *     https://formspree.io/f/abcdwxyz
 *     https://api.web3forms.com/submit      (also set ACCESS_KEY below)
 */
const ENDPOINT = "";
const ACCESS_KEY = ""; // Web3Forms only; leave empty for other services.

// Where to send people after a successful submit. Empty = stay put and show
// the inline success message (matches the original site's behaviour).
const REDIRECT_AFTER_SEND = "";

const MESSAGES = {
  sent: "Thank you for your message. It has been sent.",
  invalid: "One or more fields have an error. Please check and try again.",
  failed: "There was an error trying to send your message. Please try again, or call us at 03 7019 5873.",
  unconfigured:
    "This form isn't connected yet. Please call 03 7019 5873 or email sales@truewayremovals.com.au.",
};

const LABELS = {
  "your-name": "Full Name",
  "your-email": "Email",
  "phone-number": "Phone Number",
  "your-movedate": "Moving Date",
  "origin-zip": "Origin Address",
  "destination-zip": "Destination Address",
  "move-size": "Move Size",
  "your-referral": "Referral Source",
  "textarea-705": "Inventory List",
};

const REQUIRED = [
  "your-name",
  "your-email",
  "phone-number",
  "your-movedate",
  "origin-zip",
  "destination-zip",
  "move-size",
  "your-referral",
];

function setStatus(form, status, message) {
  form.setAttribute("data-status", status);
  form.classList.remove("sent", "invalid", "failed", "submitting");
  if (status !== "init") form.classList.add(status);

  const out = form.querySelector(".wpcf7-response-output");
  if (!out) return;
  out.textContent = message || "";
  out.setAttribute("aria-hidden", message ? "false" : "true");
  if (message) out.setAttribute("role", "alert");
}

function clearFieldErrors(form) {
  form.querySelectorAll(".wpcf7-not-valid-tip").forEach((n) => n.remove());
  form.querySelectorAll(".wpcf7-not-valid").forEach((n) => n.classList.remove("wpcf7-not-valid"));
}

function markInvalid(field, text) {
  field.classList.add("wpcf7-not-valid");
  field.setAttribute("aria-invalid", "true");
  const tip = document.createElement("span");
  tip.className = "wpcf7-not-valid-tip";
  tip.setAttribute("aria-hidden", "true");
  tip.textContent = text;
  (field.closest(".wpcf7-form-control-wrap") || field.parentNode).appendChild(tip);
}

// The selects use a placeholder option with a real value ("--Move Size",
// "--Choose One"), so a plain emptiness check would let it through unselected.
function isBlank(value) {
  const v = value.trim();
  return v === "" || v.startsWith("--");
}

function validate(form) {
  clearFieldErrors(form);
  let ok = true;

  for (const name of REQUIRED) {
    const field = form.querySelector(`[name="${name}"]`);
    if (!field) continue;
    if (isBlank(field.value)) {
      markInvalid(field, field.tagName === "SELECT" ? "Please select an option." : "Please fill out this field.");
      ok = false;
    }
  }

  const email = form.querySelector('[name="your-email"]');
  if (email && email.value.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) {
    markInvalid(email, "Please enter a valid email address.");
    ok = false;
  }

  const phone = form.querySelector('[name="phone-number"]');
  if (phone && phone.value.trim() && phone.value.replace(/\D/g, "").length < 10) {
    markInvalid(phone, "Please enter a valid phone number.");
    ok = false;
  }

  if (!ok) {
    const first = form.querySelector(".wpcf7-not-valid");
    if (first) first.focus({ preventScroll: false });
  }
  return ok;
}

function payload(form) {
  const data = { _subject: "New moving quote request — truewayremovals.com.au" };
  if (ACCESS_KEY) data.access_key = ACCESS_KEY;

  for (const [name, label] of Object.entries(LABELS)) {
    const field = form.querySelector(`[name="${name}"]`);
    if (field) data[label] = field.value.trim();
  }
  data["Submitted from"] = location.href;
  return data;
}

async function submit(form) {
  if (!validate(form)) {
    setStatus(form, "invalid", MESSAGES.invalid);
    return;
  }

  if (!ENDPOINT) {
    setStatus(form, "failed", MESSAGES.unconfigured);
    console.warn("[quote-form] ENDPOINT is empty — set it in assets/quote-form.js.");
    return;
  }

  form.classList.add("submitting");
  setStatus(form, "submitting", "Sending…");

  try {
    const res = await fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload(form)),
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);

    form.reset();
    clearFieldErrors(form);
    setStatus(form, "sent", MESSAGES.sent);
    if (REDIRECT_AFTER_SEND) setTimeout(() => (location.href = REDIRECT_AFTER_SEND), 800);
  } catch (err) {
    console.error("[quote-form] submit failed:", err);
    setStatus(form, "failed", MESSAGES.failed);
  }
}

// Contact Form 7 injects <span class="wpcf7-spinner"> after the submit button
// from JavaScript, not from the server markup. That span is visibility:hidden but
// still occupies 24px plus margins, so without it the form is 30px shorter, the
// hero section shrinks, and the door image — sized with background-size:contain —
// renders smaller than on the original site. Recreate it.
// The stylesheet already reveals it while the form carries .submitting, so it
// doubles as the sending indicator.
function addSpinners(root = document) {
  for (const submit of root.querySelectorAll("form.wpcf7-form .wpcf7-submit")) {
    const next = submit.nextElementSibling;
    if (next && next.classList.contains("wpcf7-spinner")) continue;
    const span = document.createElement("span");
    span.className = "wpcf7-spinner";
    submit.after(span);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => addSpinners());
} else {
  addSpinners();
}

document.addEventListener(
  "submit",
  (ev) => {
    const form = ev.target.closest("form.wpcf7-form");
    if (!form) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    submit(form);
  },
  true // capture, so this runs before any leftover plugin handler
);
